import { ChainId } from '@uniswap/sdk'
import MULTICALL_ABI from './abi.json'

const MULTICALL_NETWORKS: { [chainId in ChainId]: string } = {
  [ChainId.MAINNET]: '0xeefBa1e63905eF1D7ACbA5a8513c70307C1cE441',
  [ChainId.WCHAIN]: '0xcA11bde05977b3631167028862bE2a173976CA11',
  [ChainId.WCHAIN_TESTNET]: '0xEdB8008031141024d50cA2839A607B2f82C1c045',
  [ChainId.BNB]: '0xcA11bde05977b3631167028862bE2a173976CA11'
}

export { MULTICALL_ABI, MULTICALL_NETWORKS }
